import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-auto-flight-switch',
    templateUrl: './auto-flight-switch.component.html',
    styleUrls: ['./auto-flight-switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AutoFlightSwitchComponent),
            multi: true
        }
    ],
    standalone: false
})
export class AutoFlightSwitchComponent implements ControlValueAccessor, OnInit {


    onChange: any = () => { };
    onTouch: any = () => { };
    _value: boolean;

    set value(val) {
        if (val !== undefined && this._value !== val) {
            this._value = val;
            this.onChange(val);
            this.onTouch(val);
        }
    }
    get value(): boolean {
        return this._value;
    }

    // this method sets the value programmatically
    writeValue(value: any): void {
        this.value = value;
    }
    // upon UI element value changes, this method gets triggered
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }
    // upon touching the element, this method gets triggered
    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    setDisabledState?(isDisabled: boolean): void {

    }
    constructor(private cd: ChangeDetectorRef) { }
    ngOnInit(): void {
        setInterval(() => {
            this.cd.detectChanges();
        }, 1000);
    }


}
